import { FieldError } from '../../../../services/collectionApi';
import { CollectionAgreement } from './collectionAgreementModel';

export const POLICY_REQUIRED_MESSAGE = 'Escolha a política de cobrança.';

/** O que impede gravar o acordo, conferido antes de chamar o billing, com a mensagem para o usuário (AF-4057, R6). */
export const agreementDraftErrors = (draft: CollectionAgreement): FieldError[] =>
    (draft.policyId || '').trim() ? [] : [{ fieldName: 'policyId', message: POLICY_REQUIRED_MESSAGE }];
